module.exports = __webpack_public_path__ + "assets/media/stop.f29751f6.svg";